/*
 * Copyright (c) 2018-2023 MemberCenter, a subsidiary of Cameron Collective
 *   All Rights Reserved
 */
import './bootstrap.css';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

export default function Address() {
	return (
		<Grid container spacing={2} sx={{ margin: 0 }}>
			<Grid item xs={12} className="form-group">
				<label for="street">Street</label>
				<input type="text" class="form-control" id="street" />
			</Grid>
			<Grid item xs={6} className="form-group">
				<label for="city">City</label>
				<input type="text" class="form-control" id="city" />
			</Grid>
			<Grid item xs={6} className="form-group">
				<label for="state">State</label>
				<input type="text" class="form-control" id="state" />
			</Grid>
			<Grid item xs={6} className="form-group">
				<Box className="form-group">
					<label for="zip">Zip</label>
					<input type="text" class="form-control" id="zip" />
				</Box>
			</Grid>
		</Grid>
	);
}
